import React from 'react'
import assets from '../utils/assets';
import styles from "../pages/pages.module.scss";

const TaxFillingComp = () => {
  return (
    <img src={assets.taxfilling} alt='' className={`img-fluid ${styles.mHeight194}`} />
  )
}

export default TaxFillingComp;